import { IconOctagonX } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t, tPlural } from '../i18n';
import type { PlanStopTarget } from '../lib/planStop';
import { ConfirmDialog } from './ConfirmDialog';

// Stop confirmation for a whole epic (#1906) — pure presenter; the parent owns
// the mutation. `plan === null` keeps the dialog closed.
//
// It NAMES what it is about to stop, for the same reason the task confirm does:
// a destructive confirm that identifies nothing is one people click through. A
// plan has no title column of its own, so the headline is its lead slice — the
// `leadTitle` convention the epics index already uses — beside the number of
// unfinished slices the stop would actually reach.

export type StopPlanModalProps = {
  readonly plan: PlanStopTarget | null;
  readonly onConfirm: () => void;
  readonly onClose: () => void;
};

export function StopPlanModal(props: StopPlanModalProps): JSX.Element {
  const body = (): string => {
    const plan = props.plan;
    if (plan === null) return '';
    return tPlural('fleet.stop.plan_body', plan.count, {
      count: String(plan.count),
      lead: plan.lead,
    });
  };
  return (
    <ConfirmDialog
      open={props.plan !== null}
      title={t('fleet.stop.plan_title')}
      desc={body()}
      media={<IconOctagonX />}
      cancelLabel={t('fleet.stop.cancel')}
      actionLabel={t('fleet.stop.plan_confirm')}
      destructive
      onCancel={props.onClose}
      onConfirm={props.onConfirm}
    />
  );
}
